import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import { Table } from '@components/Table';

import { accountingLocationName } from '@utils/accountingLocationHelper';
import { formatTimestamp } from '@utils/dateTimeFormatter';

import { TaskData } from '@api/generator';

import { filterTask } from '@service/taskManagement';

import styles from '../taskManagement.module.scss';

const columnHelper = createColumnHelper<TaskData>();

const languageNamespace = 'task-management';
interface TaskHistoryProps {
  data: TaskData[];
}
export const TaskHistory = ({ data }: TaskHistoryProps) => {
  const { t } = useTranslation(languageNamespace);
  const records = filterTask('history', data);

  const columns = [
    columnHelper.accessor('task', {
      header: t('task'),
      cell: (info) => {
        return (
          <div data-testid={`taskAndEntity-${info?.row?.index}`} className={styles.taskLabel}>
            {info.getValue() +
              ' - ' +
              accountingLocationName(info?.row?.original?.accountingLocationName)}
          </div>
        );
      },
    }),
    columnHelper.accessor('runDateTime', {
      header: t('dueDate'),
      cell: (info) => formatTimestamp(info.getValue(), 'date'),
    }),
    columnHelper.accessor('status', {
      header: t('status'),
      cell: (info) => (
        <div className={styles[info.getValue()?.toLowerCase()]}>{info.getValue()}</div>
      ),
    }),
    columnHelper.accessor('updatedBy.userName', {
      header: t('completedBy'),
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('completionTimestamp', {
      header: t('completionDate'),
      cell: (info) => {
        if (info.row.original?.status?.toLowerCase() === 'incomplete') return '';
        return formatTimestamp(info.getValue(), 'datetime');
      },
    }),
  ] as ColumnDef<unknown, unknown>[];

  return (
    <Table
      columns={columns}
      data={records}
      showFooter={false}
      headerClassName={styles.headerTitle}
      isPaginated={false}
    />
  );
};
